module.exports = __webpack_public_path__ + "static/assets/c7677a6544c6fc72f72bc7ca5610f12d.jpg";